module.exports = "https://cdn.realtymogul.com/static/media/down_blk.4b342189.svg";